import { render, staticRenderFns } from "./PeriodReport.vue?vue&type=template&id=c456e5b0&"
import script from "./PeriodReport.vue?vue&type=script&lang=js&"
export * from "./PeriodReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports